import { Rect } from '@st/geom'
import { ReactNode } from 'react'

type Props = {
  bounds: Rect
  onClick?: () => void
  onDoubleClick?: () => void
  ariaLabel?: string
  children: ReactNode
}
export function ViewElementContainer({
  bounds,
  children,
  onClick,
  onDoubleClick,
  ariaLabel
}: Props) {
  return (
    <div
      role={onClick ? 'button' : undefined}
      tabIndex={onClick ? 0 : undefined}
      aria-label={ariaLabel}
      onClick={
        onClick
          ? (e) => {
              e.stopPropagation()
              e.preventDefault()

              onClick()
            }
          : undefined
      }
      onDoubleClick={
        onDoubleClick
          ? (e) => {
              e.stopPropagation()
              e.preventDefault()

              onDoubleClick()
            }
          : undefined
      }
      style={{
        position: 'absolute',
        boxSizing: 'border-box',
        top: bounds.y,
        left: bounds.x,
        width: bounds.width,
        height: bounds.height,
        cursor: onClick ? 'pointer' : undefined
      }}
    >
      {children}
    </div>
  )
}
